import axios from 'axios';
import {buildQuery} from 'utils/QueryUtils';

export const findLocations = (headers, params) => {
  let query = buildQuery(params);
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/locations${query}`, {
    headers,
  });
};

export const findLocationById = (headers, id) => {
  return axios.get(`${process.env.REACT_APP_INFO_API_URL}/locations/${id}`, {
    headers,
  });
};

export const createLocation = (headers, data) => {
  return axios.post(`${process.env.REACT_APP_INFO_API_URL}/locations`, data, {
    headers,
  });
};

export const updateLocation = (headers, id, data) => {
  return axios.patch(
    `${process.env.REACT_APP_INFO_API_URL}/locations/${id}`,
    data,
    {
      headers,
    },
  );
};

export const deleteLocation = (headers, id) => {
  return axios.delete(`${process.env.REACT_APP_INFO_API_URL}/locations/${id}`, {
    headers: headers,
  });
};
